import React, { useState } from "react";

const AddToolForm = ({ existingCategories, onSubmit, isSubmitting, error, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    categoryCustom: "",
    description: "",
    command: "",
  });
  const [formError, setFormError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
    setFormError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError("");

    const category = formData.category || formData.categoryCustom;

    if (!formData.name.trim()) {
      setFormError("Tool name is required");
      return;
    }

    if (!category.trim()) {
      setFormError("Category is required");
      return;
    }

    if (!formData.description.trim()) {
      setFormError("Description is required");
      return;
    }

    if (!formData.command.trim()) {
      setFormError("Command name is required");
      return;
    }

    // Validate command format
    if (!/^[a-zA-Z0-9_-]+$/.test(formData.command.trim())) {
      setFormError("Command must contain only alphanumeric characters, hyphens, and underscores");
      return;
    }

    try {
      await onSubmit({
        name: formData.name.trim(),
        category: category.trim(),
        description: formData.description.trim(),
        command: formData.command.trim(),
      });

      // Reset form on success
      setFormData({
        name: "",
        category: "",
        categoryCustom: "",
        description: "",
        command: "",
      });

      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      setFormError(err.message || "Failed to add tool");
    }
  };

  return (
    <div className="manage-tools-add-form-container">
      <h3>Add New Tool</h3>
      <form onSubmit={handleSubmit} className="manage-tools-add-form">
        {(formError || error) && (
          <div className="manage-tools-error">{formError || error}</div>
        )}

        <div className="manage-tools-form-group">
          <label htmlFor="name">Tool Name *</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="e.g., My Custom Scanner"
            required
          />
        </div>

        <div className="manage-tools-form-row">
          <div className="manage-tools-form-group">
            <label htmlFor="category">Category *</label>
            <select
              id="category"
              name="category"
              value={formData.category}
              onChange={handleChange}
            >
              <option value="">-- Select or create new --</option>
              {existingCategories.map(cat => (
                <option key={cat} value={cat}>{cat}</option>
              ))}
            </select>
          </div>

          {!formData.category && (
            <div className="manage-tools-form-group">
              <label htmlFor="categoryCustom">New Category</label>
              <input
                type="text"
                id="categoryCustom"
                name="categoryCustom"
                value={formData.categoryCustom}
                onChange={handleChange}
                placeholder="e.g., Custom Scanning"
              />
            </div>
          )}
        </div>

        <div className="manage-tools-form-group">
          <label htmlFor="description">Description *</label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="What does this tool do? What findings will it produce?"
            rows="3"
            required
          />
        </div>

        <div className="manage-tools-form-group">
          <label htmlFor="command">
            Command Name *
            <span className="manage-tools-help-text">(e.g., my-scanner, nmap, etc.)</span>
          </label>
          <input
            type="text"
            id="command"
            name="command"
            value={formData.command}
            onChange={handleChange}
            placeholder="Command to execute"
            required
          />
          <small className="manage-tools-form-hint">
            Only alphanumeric characters, hyphens, and underscores allowed. No spaces or special characters.
          </small>
        </div>

        <div className="manage-tools-form-group">
          <label className="manage-tools-info-box">
            <strong>ℹ️ Parser Pending Notice</strong>
            <p>
              New tools will be registered but show as "parser pending" until a developer 
              adds a dedicated runner/parser function in the backend. The tool will check 
              if the binary is installed, but custom result parsing is not yet available.
            </p>
          </label>
        </div>

        <div className="manage-tools-form-actions">
          <button
            type="submit"
            className="primary-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Adding Tool..." : "Add Tool"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddToolForm;
